import React from "react";
import { MapPin } from "lucide-react";
import { quartiers } from "../mock";
import useReveal from "../hooks/useReveal";

function QuartierCard({ q, i }) {
  const [ref, inView] = useReveal();
  return (
    <article
      ref={ref}
      data-testid={`quartier-card-${q.id}`}
      className={`group bg-card border border-border rounded-2xl p-7 hover:border-accent/50 hover:shadow-lg transition-[box-shadow,border-color] duration-300 reveal ${inView ? "in-view" : ""}`}
      style={{ animationDelay: `${i * 0.08}s` }}
    >
      <div className="flex items-center gap-3">
        <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 text-primary group-hover:bg-accent group-hover:text-accent-foreground transition-colors">
          <MapPin className="h-5 w-5" strokeWidth={1.7} />
        </span>
        <h3 className="font-serif text-xl font-semibold text-foreground">{q.name}</h3>
      </div>
      <p className="text-muted-foreground text-[15px] leading-relaxed mt-4">{q.text}</p>
      <div className="flex flex-wrap gap-2 mt-5">
        {q.tags.map((t) => (
          <span key={t} className="text-xs px-3 py-1 rounded-full bg-secondary text-foreground/75">{t}</span>
        ))}
      </div>
    </article>
  );
}

export default function Quartiers() {
  return (
    <section id="quartiers" data-testid="quartiers-section" className="py-24 md:py-32 bg-background">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-2xl mb-14">
          <span className="eyebrow-line text-accent tracking-[0.3em] text-xs font-medium uppercase">Nos quartiers</span>
          <h2 className="font-serif text-4xl md:text-5xl font-semibold mt-5 text-foreground">
            Boulogne-Billancourt, quartier par quartier
          </h2>
          <p className="text-muted-foreground mt-4 text-lg">
            Installés route de la Reine, nous connaissons chaque rue, chaque copropriété et l'évolution des prix de votre secteur.
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {quartiers.map((q, i) => (
            <QuartierCard key={q.id} q={q} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
